<template>
  <v-col cols="12" :md="cols" class="pa-0 px-2" style="min-width: 0;">
    <v-btn outlined color="#002245" :height="dense ? 40 : 56" class="selector-btn" block @click="showValues" :title="title">
      <v-icon color="#002245">mdi-gesture-double-tap</v-icon>
      <span class="selector-btn__text">
        <span class="selector-btn__label">{{ label }}</span>
        <span class="selector-btn__value" :class="{ 'selector-btn__value--small': isLongValue }">{{ showValue || (hidePlaceholder ? '' : title) }}</span>
      </span>
    </v-btn>
  </v-col>
</template>

<script>
export default {
  name: 'ModalInput',
  
  model: {
    prop: 'value',
    event: 'update:value'
  },

  emit: ['update:value', 'select', 'click'],
  
  props: {
    label: { type: String, default: 'ENTRADA' },
    title: { type: String, default: 'SELECCIONAR ELEMENTO' },
    cols: { type: Number, default: 12 },
    tableProps: {
      type: Object,
      default: () => ({ headers: [], items: [] })
    },
    tableSlots: { type: Object, default: () => ({}) },
    value: { type: [String, Object], default: '' },
    valueName: { type: String, default: '' },
    /** Oculta el `title` como texto de relleno cuando todavía no hay valor elegido. */
    hidePlaceholder: { type: Boolean, default: false },
    /** Alto de campo `dense` de Vuetify (40px, como BaseSelectorGestion) en vez de 56px. */
    dense: { type: Boolean, default: false },
  },


  data() {
    return {
      showValue: typeof this.value === 'string' ? this.value : ''
    }
  },

  computed: {
    isLongValue() {
      return (this.showValue || '').length > 30;
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (typeof newValue === 'string') {
          this.showValue = newValue;
        } else if (newValue && typeof newValue === 'object') {
          this.showValue = this.valueName ? newValue[this.valueName] : newValue[Object.keys(newValue)[0]];
        }
      }
    }
  },

  methods: {
    showValues() {
      this.$emit('click')
      this.$store.dispatch('openModal', {
        component: 'TableModal',
        props: {
          title: this.title,
          headers: this.tableProps.headers,
          items: this.tableProps.items,
          style: this.tableProps.styles || {},
          ...this.tableProps
        },
        events: {
          select: (item) => {
            const newValue = this.valueName ? item[this.valueName] : item[Object.keys(item)[0]];
            this.showValue = newValue.toString();
            
            this.$emit('update:value', item);
            this.$emit('select',item)
            this.$store.dispatch('closeTopModal');
          }
        },
        slots: this.tableSlots 
      });
    }
  }
}
</script>

<style scoped>

.selector-btn {
  border-width: 1.5px !important;
  border-radius: 8px !important;
  justify-content: flex-start !important;
  text-transform: none !important;
  min-width: 0 !important;
  width: 100% !important;
  flex-shrink: 1 !important;
}
.selector-btn ::v-deep .v-btn__content {
  min-width: 0;
  overflow: hidden;
  width: 100%;
}
.selector-btn__text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 8px;
  line-height: 1.2;
  min-width: 0;
  width: 100%;
  flex: 1 1 auto;
}
.selector-btn__label {
  font-size: 0.73rem;
  font-weight: 600;
  color: #55606e;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.selector-btn__value {
  font-size: 0.85rem;
  font-weight: 700;
  color: #002245;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.selector-btn__value--small {
  font-size: 0.68rem;
}
</style>